import React from 'react';
import { useFormikContext } from 'formik';
import moment from 'moment';
import { FormDatePicker } from '../form-helpers/FormField';

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
}

const MobileDateQuestion = ({fieldName}) => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <>
      <FormDatePicker
        type="date"
        name={fieldName}
        value={moment(values[fieldName])}
        format="YYYY-MM-DD"
        style={{ width: '100%', padding: '3%' }}
        onChange={(e) => {
          if (e !== null) {
            setFieldValue(fieldName, e)
          }
        }}
        disabledDate={current => {
          return current && current > moment();
        }}
        formItemLayout={formItemLayout}
      />
    </>
  );
}

export default MobileDateQuestion;
